// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 347 ? "SVG" : chunkId) + "." + {"181":"f87db464","347":"d50de807","389":"5dd6283f","939":"5227e8d8"}[chunkId] + ".chunk.js";
};